var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',[_c('img',{attrs:{"width":"100","height":"100","src":require("@/assets/icon/img_start_loading.gif"),"alt":""}})])])
}]

export { render, staticRenderFns }